
export default class Component {
	/**
	 * 
	 * @param {*} $element 
	 * @param {*} scope 
	 * @param {App} app 
	 */
	constructor($element, scope, app) {
		/**
		 * @type {App}
		 */
		this.app = app;
		this.dom = this.app.dom;
		this.scope = scope || {};
		this.isDestroyed = false;
		this.$element = $element;
		this.className = this.constructor.name;
		this._events = [];
		
		this.$element.setAttribute(`data-kr-${this.className}`, 'initialized');
		this.$element.addEventListener('destroy', event => {
			if(event.currentTarget.dataset.triggered) {
                return
            };
			event.currentTarget.dataset.triggered = true;
			this.destroy();
		});
		
		this.init();
	}

	init() {
		throw new Error("init() method should be implemented");
	}

	bind() {

	}

	tick() {

	}

	// on(events, callback) {
	// on(events, selector, callback) {
	// on(events, $target, callback) {
	// on(events, $target, selector, callback) {
	on(events, $target, selector, callback, debounce = false) {
		if (callback === undefined && selector === undefined) {
			callback = $target;
			$target = this.$element;
		} else if (callback === undefined && typeof($target) == 'string') {
			callback = selector;
			selector = $target;
			$target = this.$element;
		} else if (typeof(selector) == 'function') {
			callback = selector;
			selector = undefined;
		}

		// console.log('events', events, '$target', $target, 'selector', selector, 'callback', callback);

		// if debounce _.debounce(callback, debounce)
		const $callback = this._wrapCallback(selector, $target, callback);

		this._events.push({
			events: events,
			$target: $target,
			selector: selector,
			callback: callback,
			wrapCallback: $callback
		});
		$target.addEventListener(events, this._events[this._events.length -1].wrapCallback, true);
		return this;
	}

	off(events, $target, selector, callback) {
		if (callback === undefined && selector === undefined) {
			callback = $target;
			$target = this.$element;
		} else if (callback === undefined && typeof($target) == 'string') {
			callback = selector;
			selector = $target;
			$target = this.$element;
		} else if (typeof(selector) == 'function') {
			callback = selector;
			selector = undefined;
		}
		
		let eventIndex;
		this._events.forEach((item, index) => {
			if (item.events === events && item.$target === $target &&
				item.selector === selector && item.callback === callback) {
				eventIndex = index;
			}
		});
		if (typeof this._events[eventIndex] === 'undefined' || typeof this._events[eventIndex].wrapCallback === 'undefined') {
			return this;
		}
		$target.removeEventListener(events, this._events[eventIndex].wrapCallback, true);
		this._events.splice(eventIndex, 1);
		return this;
	}

	destroy() {
		if (!this.isDestroyed) {
			this.isDestroyed = true;

			this._events.forEach((item, index) => {
				this.off(item.events, this._events[index].wrapCallback);
				this._events.splice(index, 1);
			});
		}
		return this;
	}

	_wrapCallback(selector, $target, callback) {
		if (selector !== undefined) {
			return event => {
				const target = event.target;
				const eventArray = this._checkEventTarget(selector, target, event);
				if (!eventArray.if) return;
				callback(eventArray.target, event);
			};
		} else {
			return event => {
				callback($target, event);
			};
		}
	}

	_checkEventTarget(selector, target, event) {
		let toReturn = false;
		let obj = target;
		if (target.matches(selector)) {
			toReturn = true;
		} else {
			const paths = event.path || (event.composedPath && event.composedPath());
			for (let i in paths) {
				if (paths[i] == this.$element) {
					break;
				}
				if (paths[i].matches(selector)) {
					toReturn = true;
					obj = paths[i];
					break;
				}
			}
		}
		return {
			if: toReturn,
			target: obj
		};
	}
}

